import { z } from 'zod';

export const instagramUsernameValidation = z
  .string()
  .trim()
  .min(4, { message: 'Provide min 4 chars' })
  .nonempty({ message: 'Please provide username' })
  .regex(
    new RegExp(/^(?!https|www|instagram.com).*$/),
    'Please provide instagram username, url is not valid',
  )
  .regex(new RegExp(/^(?!@).*$/), 'Please provide instagram username without @')
  .regex(/^[a-zA-Z0-9._]+$/, {
    message:
      'Please provide valid instagram username. Allowed special characters are "_" and "."',
  });
